// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z8lv","question":"styles_question__2onat","description":"styles_description__2ZO_l"};